// JavaScript code for acf_blocks/events-promenade component
(($) => {
  "use strict";
  jQuery(function ($) {
    const $cards = $(".events-overlap .events-card");
    if (!$cards.length || typeof gsap === "undefined") return;

    const $first = $cards.eq(0); // vivid on load

    /* ---------------- Hover in ---------------- */
    $cards.on("mouseenter", function () {
      const $self = $(this);

      // Dim everyone else
      gsap.to($cards.not($self), {
        opacity: 0.25,
        duration: 0.2,
        overwrite: true,
      });

      $cards
        .not($self)
        .removeClass("events-card--active")
        .addClass("events-card--muted");

      // Light up hovered card
      $self.removeClass("events-card--muted").addClass("events-card--active");

      gsap.to($self, { opacity: 1, duration: 0.2, overwrite: true });
    });

    /* ---------------- Hover out of wrapper ---------------- */
    $(".events-overlap").on("mouseleave", function () {
      // Reset non-first cards
      $cards
        .not($first)
        .removeClass("events-card--active")
        .addClass("events-card--muted");

      gsap.to($cards.not($first), {
        opacity: 0.25,
        duration: 0.2,
        overwrite: true,
      });

      // Restore the left-most card as active
      $first.removeClass("events-card--muted").addClass("events-card--active");

      gsap.to($first, { opacity: 1, duration: 0.2, overwrite: true });

			
    });

		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    // Set initial hidden state (optional if you have it in CSS already)
    gsap.set(".animation-top", { y: 40, autoAlpha: 0 });

    gsap.timeline({
        defaults: { ease: "power3.out" },
        scrollTrigger: {
            trigger: ".animation-top", // top headline = trigger point
            start: "top 75%",               // fire when the element’s top hits 75% vh
            toggleActions: "play none none reverse" // scrub back on scroll-up
            //     ^ play on enter | no action on leave | no action on enter-back | reverse on leave-back
        }
    })
    .to(".animation-top", {
        duration: 1,
        y: 0,
        autoAlpha: 1,
        stagger: 0.25
    });  


  });
})(jQuery);
